import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";

export const useIsProfileFieldsEnabled = (): boolean => {
  const { currentCommunity, isLoading }: any = usePunditUserContext();

  return !!(
    !isLoading && currentCommunity?.profile_fields_feature_flag_enabled
  );
};

export function useShouldShowProfileFieldsUpgradeModal(): boolean {
  const { currentCommunityMember }: any = usePunditUserContext();

  const isProfileFieldsEnabled = useIsProfileFieldsEnabled();
  const isAdmin = currentCommunityMember?.is_admin;

  return Boolean(!isProfileFieldsEnabled && isAdmin);
}
